<template>
<div class="chapter">
<div class="inner_page">
<h3 class="h3"><a id="file_035">WINGS</a></h3><a id="file_035">
<p class="noindent"><strong>3.</strong> Fold a piece of white wool into the size and shape of a thumbnail. Needle the surface. Make two.</p>
<p class="image"><img alt="Image" src="images/f0014-04.jpg"/></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// file_035.vue?484acc0f